import { createFileRoute, notFound } from "@tanstack/react-router";

import {
  CONTENT_CACHE_CONTROL,
  CONTENT_NOT_FOUND_CACHE_CONTROL,
} from "@/content/cachePolicy";
import { NotFoundPage } from "@/components/landing/LandingNotFound";
import PricingPage from "./pricing/-components/PricingPage";
import { pricingPageCms } from "./pricing/-components/pricingSource";
import { topLocationsCms } from "@/content/locationSource";

/**
 * Prerendered from the CMS, as every marketing page is: the words and the
 * figures are the Pricing page document's, the tables print the Prices lists,
 * as Webflow printed its price collections. Nothing asks the billing backend.
 *
 * A sibling of `_app` for the reason `blog`, `academy` and `home` are: the page
 * is public and `_app`'s guard would bounce an anonymous visitor to sign-in.
 */
export const Route = createFileRoute("/pricing")({
  loader: async () => {
    const [content, locations] = await Promise.all([
      pricingPageCms(),
      topLocationsCms(),
    ]);
    if (!content) {
      throw notFound();
    }
    return { content, locations };
  },
  headers: ({ loaderData }) => ({
    "Cache-Control": loaderData
      ? CONTENT_CACHE_CONTROL
      : CONTENT_NOT_FOUND_CACHE_CONTROL,
  }),
  // No `og:url` and no structured data: the published page prints neither.
  component: PricingRoute,
  notFoundComponent: NotFoundPage,
});

function PricingRoute() {
  const { content, locations } = Route.useLoaderData();
  return <PricingPage content={content} locations={locations} />;
}
